import React from "react";
import { Helmet } from "react-helmet-async";

const PageTitle = ({ title }) => {
  return (
    <Helmet>
      <title>Claudiu Sas / {title}</title>
    </Helmet>
  );
};

export default PageTitle;
